/* ==========================================================================
   NOURISH — Collection filtering and sorting
   Uses the Section Rendering API and history.pushState so filtered views are
   shareable, bookmarkable, and survive the back button.
   ========================================================================== */

(function () {
  'use strict';
  const Nourish = window.Nourish;
  if (!Nourish) return;

  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.debouncedSubmit = Nourish.debounce(() => this.apply(), 320);

      this.addEventListener('change', (e) => {
        if (e.target.matches('input[type="checkbox"], select')) this.apply();
      });
      this.addEventListener('input', (e) => {
        if (e.target.matches('input[type="number"], input[type="range"]')) this.debouncedSubmit();
      });

      document.addEventListener('click', (e) => {
        const clear = e.target.closest('[data-facet-remove]');
        if (clear) {
          e.preventDefault();
          this.apply(clear.getAttribute('href'));
        }
      });

      window.addEventListener('popstate', (e) => {
        this.render(window.location.search, false);
      });
    }

    apply(explicitUrl) {
      const search = explicitUrl
        ? explicitUrl.split('?')[1] || ''
        : new URLSearchParams(new FormData(this.form)).toString();
      this.render('?' + search, true);
    }

    async render(search, push) {
      const grid = document.getElementById('product-grid');
      const facets = document.getElementById('facets');
      if (grid) grid.classList.add('facets-loading');
      if (grid) grid.setAttribute('aria-busy', 'true');

      const url = window.location.pathname + (search.startsWith('?') ? search : '?' + search);

      try {
        const doc = await Nourish.fetchSection(this.section, url);

        const freshGrid = doc.getElementById('product-grid');
        if (grid && freshGrid) grid.innerHTML = freshGrid.innerHTML;

        const freshFacets = doc.getElementById('facets');
        if (facets && freshFacets) {
          // Preserve which filter groups the shopper had expanded
          const openGroups = Array.from(facets.querySelectorAll('details[open]')).map(
            (d) => d.dataset.facetKey
          );
          facets.innerHTML = freshFacets.innerHTML;
          openGroups.forEach((key) => {
            const el = facets.querySelector(`details[data-facet-key="${key}"]`);
            if (el) el.open = true;
          });
        }

        const freshCount = doc.querySelector('[data-facet-count]');
        const count = document.querySelector('[data-facet-count]');
        if (count && freshCount) count.textContent = freshCount.textContent;

        if (push) window.history.pushState({ search: search }, '', url);

        document.dispatchEvent(new CustomEvent('facets:rendered'));
      } catch (err) {
        Nourish.toast(Nourish.strings.cartError || 'Could not load results', 'error');
      } finally {
        if (grid) {
          grid.classList.remove('facets-loading');
          grid.setAttribute('aria-busy', 'false');
        }
      }
    }
  }
  customElements.define('facet-filters', FacetFilters);

  /* ------------------------------------------------------------------------
     Grid / list toggle — remembered for the session only
     ------------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-view-toggle]');
    if (!btn) return;
    const view = btn.dataset.viewToggle;
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    grid.classList.toggle('product-grid--list', view === 'list');
    document.querySelectorAll('[data-view-toggle]').forEach((b) =>
      b.setAttribute('aria-pressed', String(b.dataset.viewToggle === view))
    );
    try {
      sessionStorage.setItem('nourish:collection-view', view);
    } catch (err) {}
  });

  document.addEventListener('DOMContentLoaded', function () {
    let view;
    try {
      view = sessionStorage.getItem('nourish:collection-view');
    } catch (e) {}
    if (view === 'list') {
      const btn = document.querySelector('[data-view-toggle="list"]');
      if (btn) btn.click();
    }
  });
})();
